import { AppProviders } from "./providers";
import { AppRouter } from "./router/index.tsx";
import { ZustandDebugPanel } from "@/shared/components/ZustandDebugPanel";
import "../index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "devextreme/dist/css/dx.light.compact.css";
import "devexpress-gantt/dist/dx-gantt.min.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import "@toast-ui/editor/dist/theme/toastui-editor-dark.css";
import "@toast-ui/editor-plugin-table-merged-cell/dist/toastui-editor-plugin-table-merged-cell.css";
import "react-datepicker/dist/react-datepicker.css";

function App() {
  console.log("FSD Architecture - version 2.0.0");

  return (
    <AppProviders>
      <AppRouter />
      <ZustandDebugPanel />
    </AppProviders>
  );
}

export default App;
